export const articleSafety = {
  slug: 'usfans-safety',
  en: {
    title: 'USFans Safety Guide: Privacy, Security & Scam Prevention',
    description:
      'Practical safety habits for using USFans and similar platforms, covering passwords, links, payments and personal data.',
    tag: 'Safety',
    intro: [
      'Safety online is mostly about habits. A few consistent practices protect you far more than any single tool, whether you are browsing creators or completing an order.',
      'This guide collects the most important safety rules in one place, so you can apply them across every platform you use.',
    ],
    sections: [
      {
        title: 'Account and password safety',
        paragraphs: [
          'Use a strong, unique password for every account and never share it with anyone. Enable two-factor authentication where available for an extra layer of protection.',
          'Legitimate services will never ask you for your password or verification code through email or chat.',
        ],
      },
      {
        title: 'Avoiding phishing and fake links',
        paragraphs: [
          'Type the official domain yourself or use a saved bookmark instead of clicking links from unknown messages. Check the address carefully before entering any information.',
          'Be especially careful with links that imitate popular brands or create a sense of urgency.',
        ],
      },
      {
        title: 'Payment and personal data',
        paragraphs: [
          'Only enter payment details on a secure, official checkout page. Never share full card information, verification codes or passwords with anyone, even if they claim to be support.',
          'Minimize the personal information you share and review the privacy policy to understand how it is used.',
        ],
      },
    ],
    faq: [
      { q: 'How do I stay safe on USFans?', a: 'Use strong unique passwords, enable two-factor authentication, and never share passwords or verification codes.' },
      { q: 'How do I avoid phishing?', a: 'Type the official domain yourself, avoid links from unknown messages, and check the address before entering information.' },
      { q: 'Should I share my card details?', a: 'Only enter payment details on a secure official checkout page, and never share full card info or codes with anyone.' },
    ],
  },
  pl: {
    title: 'USFans Safety Guide: prywatność, bezpieczeństwo i zapobieganie oszustwom',
    description:
      'Praktyczne nawyki bezpieczeństwa przy korzystaniu z USFans i podobnych platform: hasła, linki, płatności i dane osobowe.',
    tag: 'Bezpieczeństwo',
    intro: [
      'Bezpieczeństwo w sieci to przede wszystkim nawyki. Kilka konsekwentnych praktyk chroni Cię bardziej niż jakiekolwiek pojedyncze narzędzie, niezależnie od tego, czy przeglądasz twórców, czy składasz zamówienie.',
      'Ten przewodnik zbiera najważniejsze zasady bezpieczeństwa w jednym miejscu, abyś mógł je stosować na każdej platformie.',
    ],
    sections: [
      {
        title: 'Bezpieczeństwo konta i haseł',
        paragraphs: [
          'Używaj silnego, unikalnego hasła do każdego konta i nigdy nikomu go nie udostępniaj. Włączaj uwierzytelnianie dwuskładnikowe, gdy jest dostępne.',
          'Wiarygodne serwisy nigdy nie poproszą o hasło ani kod weryfikacyjny przez e-mail lub czat.',
        ],
      },
      {
        title: 'Unikanie phishingu i fałszywych linków',
        paragraphs: [
          'Wpisuj oficjalną domenę samodzielnie lub korzystaj z zapisanej zakładki zamiast klikać linki z nieznanych wiadomości. Sprawdzaj adres przed podaniem jakichkolwiek informacji.',
          'Uważaj szczególnie na linki imitujące popularne marki lub wywołujące poczucie pilności.',
        ],
      },
      {
        title: 'Płatności i dane osobowe',
        paragraphs: [
          'Dane płatności podawaj tylko na bezpiecznej, oficjalnej stronie realizacji zamówienia. Nigdy nie udostępniaj pełnych danych karty, kodów weryfikacyjnych ani haseł, nawet jeśli ktoś podaje się za wsparcie.',
          'Ograniczaj udostępniane dane osobowe i sprawdzaj politykę prywatności, aby zrozumieć ich wykorzystanie.',
        ],
      },
    ],
    faq: [
      { q: 'Jak być bezpiecznym na USFans?', a: 'Używaj silnych unikalnych haseł, włączaj uwierzytelnianie dwuskładnikowe i nigdy nie udostępniaj haseł ani kodów weryfikacyjnych.' },
      { q: 'Jak unikać phishingu?', a: 'Wpisuj oficjalną domenę samodzielnie, unikaj linków z nieznanych wiadomości i sprawdzaj adres przed podaniem informacji.' },
      { q: 'Czy mam podawać dane karty?', a: 'Dane płatności podawaj tylko na bezpiecznej oficjalnej stronie realizacji zamówienia i nigdy nie udostępniaj pełnych danych karty ani kodów.' },
    ],
  },
  es: {
    title: 'Guía de seguridad de USFans: privacidad, seguridad y prevención de estafas',
    description:
      'Hábitos prácticos de seguridad al usar USFans y plataformas similares: contraseñas, enlaces, pagos y datos personales.',
    tag: 'Seguridad',
    intro: [
      'La seguridad en línea depende sobre todo de los hábitos. Unas pocas prácticas constantes te protegen más que cualquier herramienta, ya sea que explores creadores o completes un pedido.',
      'Esta guía reúne las reglas de seguridad más importantes en un solo lugar para que las apliques en cada plataforma.',
    ],
    sections: [
      {
        title: 'Seguridad de cuenta y contraseñas',
        paragraphs: [
          'Usa una contraseña fuerte y única para cada cuenta y nunca la compartas. Activa la verificación en dos pasos donde esté disponible.',
          'Los servicios legítimos nunca te pedirán tu contraseña o código de verificación por correo o chat.',
        ],
      },
      {
        title: 'Evitar phishing y enlaces falsos',
        paragraphs: [
          'Escribe el dominio oficial tú mismo o usa un marcador guardado en lugar de hacer clic en enlaces de mensajes desconocidos. Revisa la dirección antes de introducir información.',
          'Ten especial cuidado con enlaces que imitan marcas conocidas o crean sensación de urgencia.',
        ],
      },
      {
        title: 'Pagos y datos personales',
        paragraphs: [
          'Introduce datos de pago solo en una página de pago oficial y segura. Nunca compartas datos completos de tarjeta, códigos de verificación ni contraseñas, aunque digan ser de soporte.',
          'Minimiza la información personal que compartes y revisa la política de privacidad para entender su uso.',
        ],
      },
    ],
    faq: [
      { q: '¿Cómo me mantengo seguro en USFans?', a: 'Usa contraseñas fuertes y únicas, activa la verificación en dos pasos y nunca compartas contraseñas ni códigos.' },
      { q: '¿Cómo evito el phishing?', a: 'Escribe el dominio oficial tú mismo, evita enlaces de mensajes desconocidos y revisa la dirección antes de introducir información.' },
      { q: '¿Debo compartir los datos de mi tarjeta?', a: 'Introduce datos de pago solo en una página oficial segura y nunca compartas datos completos de tarjeta ni códigos.' },
    ],
  },
  fr: {
    title: 'Guide de sécurité USFans : confidentialité, sécurité et prévention des arnaques',
    description:
      'Bonnes pratiques de sécurité pour USFans et plateformes similaires : mots de passe, liens, paiements et données personnelles.',
    tag: 'Sécurité',
    intro: [
      'La sécurité en ligne repose surtout sur les habitudes. Quelques pratiques constantes protègent mieux que n’importe quel outil, que vous parcouriez des créateurs ou passiez commande.',
      'Ce guide rassemble les règles de sécurité les plus importantes en un seul endroit pour les appliquer sur chaque plateforme.',
    ],
    sections: [
      {
        title: 'Sécurité du compte et des mots de passe',
        paragraphs: [
          'Utilisez un mot de passe fort et unique pour chaque compte et ne le partagez jamais. Activez la double authentification quand elle est disponible.',
          'Les services légitimes ne vous demanderont jamais votre mot de passe ni votre code de vérification par e-mail ou chat.',
        ],
      },
      {
        title: 'Éviter le phishing et les faux liens',
        paragraphs: [
          'Saisissez vous-même le domaine officiel ou utilisez un marque-page plutôt que de cliquer sur des liens de messages inconnus. Vérifiez l’adresse avant de saisir des informations.',
          'Méfiez-vous surtout des liens imitant des marques connues ou créant un sentiment d’urgence.',
        ],
      },
      {
        title: 'Paiement et données personnelles',
        paragraphs: [
          'Saisissez vos données de paiement uniquement sur une page officielle et sécurisée. Ne partagez jamais les données bancaires complètes, les codes de vérification ni les mots de passe.',
          'Limitez les informations personnelles partagées et consultez la politique de confidentialité.',
        ],
      },
    ],
    faq: [
      { q: 'Comment rester en sécurité sur USFans ?', a: 'Utilisez des mots de passe forts et uniques, activez la double authentification et ne partagez jamais mots de passe ni codes.' },
      { q: 'Comment éviter le phishing ?', a: 'Saisissez vous-même le domaine officiel, évitez les liens de messages inconnus et vérifiez l’adresse avant de saisir des informations.' },
      { q: 'Dois-je partager mes données bancaires ?', a: 'Saisissez vos données de paiement uniquement sur une page officielle sécurisée et ne partagez jamais les données complètes ni les codes.' },
    ],
  },
};